import React from 'react';
import "./Footer.css";
import logo from "../../../images/Logo2.png";
import {FaFacebookSquare, FaLinkedin, FaTiktok, FaInstagram} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer position-relative">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-4 col-lg-4">
              <div className="footer-widget footer-first">
                <div className="footer-logo">
                  <Link to={"/"}>
                    <img src={logo} alt="logo" />
                  </Link>
                </div>
                <div className="d-none d-lg-flex social-links align-items-center">
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="instagram"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/synavie"
                    target="_blank"
                    rel="noreferrer"
                    className=""
                  >
                    <FaLinkedin />
                  </a>
                </div>

                <div className="footer-email">
                  <p>kontakt@synavie.pl</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4 col-lg-4">
              <div className="footer-widget footer-second">
                <ul>
                  <li>
                    <Link to={"/o-nas"}>O Nas</Link>
                  </li>
                  <li>
                    <Link to={"/regulamin"}>Regulamin</Link>
                  </li>
                  <li>
                    <Link to={"/rodo-i-polityka-prywatnosci"}>RODO i Polityka Prywatności</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-md-4 col-lg-4">
              <div className="footer-widget footer-third">
                <ul>
                  <li>
                    <Link to={"/oferta"}>Oferta</Link>
                  </li>
                  <li>
                    <Link to={"/umow-wizyte"}>Umów wizytę</Link>
                  </li>
                  <li>
                    <Link to={"/kontakt"}>Kontakt</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
